export default __webpack_public_path__ + "static/media/desktop1.3625b16a.png";